export const formatCurrencyBRL = (amountInCents: number): string => {
	return (amountInCents / 100).toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	});
};

export const maskDocumentTail = (document: string, visibleDigits = 4): string => {
	const digitPositions: number[] = [];

	for (let index = 0; index < document.length; index++) {
		if (/\d/.test(document[index])) digitPositions.push(index);
	}

	const maskedCount = Math.max(digitPositions.length - visibleDigits, 0);
	const maskedPositions = new Set(digitPositions.slice(0, maskedCount));

	return [...document].map((char, index) => (maskedPositions.has(index) ? '*' : char)).join('');
};
